import { TraineeProps } from "@/types/admin_types";

interface Props {
  el: TraineeProps
}



export default function TraineeCard({ el }: Props) {
  return (
    <div className="group relative w-full rounded-2xl border border-neutral-200 bg-gradient-to-br from-slate-50 to-white p-6 shadow-sm transition-all hover:-translate-y-1 ">
      {/* Accent line */}
      <div className="absolute left-0 top-6 h-12 w-1 rounded-full bg-gradient-to-b from-indigo-400 to-indigo-600 transition-all group-hover:h-16" />

      {/* Header */}
      <div className="mb-4 pl-4">
        <h3 className="text-lg font-semibold tracking-tight text-slate-900">
          {el?.name}
        </h3>
        <p className="text-sm text-slate-500">
          {el?.institution} · {el?.specialization}
        </p>
      </div>

      {/* Body */}
      <div className="grid grid-cols-2 gap-y-3 gap-x-4 pl-4 text-sm">
        <div>
          <p className="text-slate-400">Identification</p>
          <p className="truncate text-slate-700">{el?.identification}</p>
        </div>
        <div>
          <p className="text-slate-400">Email</p>
          <p className="truncate text-slate-700">{el?.email}</p>
        </div>
        <div>
          <p className="text-slate-400">Phone</p>
          <p className="text-slate-700">{el?.phone}</p>
        </div>
        <div>
          <p className="text-slate-400">Duration</p>
          <p className="text-slate-700">{el?.duration}</p>
        </div>
        <div>
          <p className="text-slate-400">Training Hours</p>
          <p className="text-slate-700">{el?.training_hours} hrs</p>
        </div>
        <div>
          <p className="text-slate-400">Supervisor</p>
          <p className="text-slate-700">{el?.supervisor}</p>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-6 flex flex-col gap-1 pl-4 text-xs text-slate-500">
        <span>Student ID: {el?.student_id} · {el?.identification}</span>
        <div className="flex justify-between">
          <span>Start: {el?.start_at}</span>
          <span>End: {el?.end_at}</span>
        </div>
      </div>
    </div>
  );
};
